import styles from "./Home.module.css"
import logo from "../../images/logo.png"

const Home = () => {
  return (
      <div className={styles.home}>
      {/* <img src={logo} alt="logo" /> */}
      
      </div>
  )
}

export default Home